import { Pipe, PipeTransform } from "@angular/core";
import { ContextMenuItem, DisplayColour } from "../context-menu-item";

@Pipe({
  name: 'displayWarning'
})
export class DisplayWarningPipe implements PipeTransform {
  transform(item: ContextMenuItem): boolean {
    return (
      item.displayColour === DisplayColour.Warning
    );
  }
}